// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3o_Yr","amount":"Amount_amount__2x0-V","tip":"Amount_tip__VkhXe","tipHeader":"Amount_tipHeader__15r8C","tipsWrap":"Amount_tipsWrap__3j61b"};